/**
 *
 * Tag
 *
 */
import React, { memo, ReactNode } from 'react';

interface Props {
  label: string | ReactNode;
  className: string;
}

export const Tag = memo((props: Props) => {
  return (
    <div
      className={`rounded-md min-w-max font-semibold border-[1px] border-solid bg-opacity-20 flex justify-center items-center ${props.className}`}
    >
      {props.label}
    </div>
  );
});
